module.exports = __webpack_public_path__ + "img/1580750839.4ffda458.jpg";